import { combineReducers } from "redux";
import auth from "./auth";
import navigation from "./navigation";
import posts from "./posts";
import sidechains from "./sidechains";
import nodes from "./nodes";
import tables from "./tables";
import users from "./users";
import roles from "./roles";
import market from "./market";
import demo from "./demo";

export default combineReducers({
	auth,
	demo,
	navigation,
	nodes,
	posts,
	roles,
	sidechains,
	tables,
	users,
	market,
});
